import { render, staticRenderFns } from "./QuickEditPersonQuestionnaire.vue?vue&type=template&id=c024e014&scoped=true&"
import script from "./QuickEditPersonQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./QuickEditPersonQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./QuickEditPersonQuestionnaire.vue?vue&type=style&index=0&id=c024e014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c024e014",
  null
  
)

export default component.exports